import React, { useRef } from 'react';
import classNames from 'classnames';
import { MediafileHeader } from './MediafileHeader/MediafileHeader';
import { MediafileFields } from './MediafileFields/MediafileFields';
import { MediafileSettingsTrigger } from './MediafileSettingsTrigger/MediafileSettingsTrigger';
import { MediafileSettingsPanel } from './MediafileSettingsPanel/MediafileSettingsPanel';
import { MediafileActions } from './MediafileActions/MediafileActions';
import { DATA_TEST_IDS } from './consts';
import type { MediafileItemProps } from './types';
import styles from './index.module.scss';

export const MediafileItem: React.FC<MediafileItemProps> = ({
  id,
  title,
  poster,
  leading,
  className,
  state,
  metadata,
  statusMessage,
  settings,
  fields,
  actions,
}) => {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const hasActions = !!actions?.length;
  return (
    <div
      className={classNames(styles.container, !leading && styles.withoutLeading, className)}
      data-testid={DATA_TEST_IDS.ROOT(id)}>
      <MediafileHeader
        id={id}
        title={title}
        poster={poster}
        leading={leading}
        metadata={metadata}
        statusMessage={statusMessage}
        state={state}
      />
      {(settings || fields || hasActions) && (
        <div
          className={classNames(
            styles.lower,
            settings?.layout === 'responsive-actions' && styles.responsiveActions,
            !hasActions && styles.withoutActions
          )}>
          {settings && (
            <MediafileSettingsTrigger
              id={id}
              title={title}
              settings={settings}
              triggerRef={triggerRef}
            />
          )}
          {settings && (
            <MediafileSettingsPanel
              id={id}
              settings={settings}
              triggerRef={triggerRef}
            />
          )}
          {fields && (
            <MediafileFields
              id={id}
              fields={fields}
            />
          )}
          {hasActions && (
            <MediafileActions
              id={id}
              actions={actions!}
            />
          )}
        </div>
      )}
    </div>
  );
};
